export class HeldError extends Error {
  i18nPath: string;
  needSupport?: boolean;

  constructor(i18nPath: string, message?: string, needSupport?: boolean) {
    super(message);
    this.i18nPath = i18nPath || 'errors.SOMETHING_WENT_WRONG';
    this.needSupport = needSupport;
  }
}
